import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'confirm',
  initialState: { isOpen: false, options: null, resolver: null },
  reducers: {
    openConfirm(state, { payload }) {
      state.isOpen = true;
      state.options = payload.options;
      state.resolver = payload.resolver;
    },
    closeConfirm(state) {
      state.isOpen = false;
      state.options = null;
      state.resolver = null;
    }
  }
});

export const { openConfirm, closeConfirm } = slice.actions;
export default slice.reducer;